import { prova } from "~/routes/prova/index";
import auth from "~/middleware/auth";

const Home = () => import("~/components/Views/Home");
const NotFound = () => import("~/components/Views/NotFound");
const Forbidden = () => import("~/components/Views/Forbidden");
const Cadastro = () => import("~/components/Views/Cadastro");
const CadastroFinalizacao = () =>
  import("~/components/Views/CadastroFinalizacao");
const RedefinirSenha = () =>
  import("~/components/Views/RecuperarSenha/RedefinirSenha");
const RedefinirSenhaFinalizacao = () =>
  import("~/components/Views/RecuperarSenha/RedefinirSenhaFinalizacao");
const Logoff = () => import("~/components/Views/Logoff");
const Login = () => import("~/components/Views/Login");
const LoginInterno = () => import("~/components/Views/LoginInterno.vue");

const breadcrumb = [
  { name: "Integrado", link: "http://on.grupointegrado.br/" }
];

const mainRoutes = [
  {
    path: "/",
    redirect: to => {
      window.location.href = "/prova/inicio";
    }
  },
  {
    path: "/cadastro",
    component: Cadastro
  },
  {
    path: "/cadastro/:usuarioLogin",
    component: CadastroFinalizacao
  },
  {
    path: "/logoff",
    component: Logoff
  },
  {
    path: "/login",
    component: Login,
    meta: {
      middleware: auth
    }
  },
  {
    path: "/login/:login/:path?",
    component: LoginInterno
  },
  {
    path: "*",
    component: NotFound,
    name: "404",
    meta: {
      breadcrumb
    }
  },
  {
    path: "/403",
    component: Forbidden,
    name: "403",
    meta: {
      breadcrumb
    }
  },
  {
    path: "/redefinir",
    component: RedefinirSenha
  },
  {
    path: "/redefinir/:usuarioLogin",
    component: RedefinirSenhaFinalizacao
  }
];

const routes = mainRoutes.concat(prova);

export default routes;



// WEBPACK FOOTER //
// ./src/routes/routes.js